export default __webpack_public_path__ + "media/JSM_right.f4959ce871aaed4cdc45eae325c8092f.svg";